import { SearchCriteria } from "@models/SearchCriteria";
import { SearchFilteringOption } from "@models/SearchFilteringOption";

export class BasicSearchCriteria extends SearchCriteria {
  public Text: string;
  public Field: string;
  public SortBy: string;
  public Offset: number;
  public FilterOptions: SearchFilteringOption[];
  public UnfilteredPlantIds: number[];

  constructor(
    Text: string,
    Field: string,
    SortBy: string,
    Offset: number,
    FilterOptions: SearchFilteringOption[] | null,
    UnfilteredPlantIds: number[] | null
  ) {
    super(
      Text,
      Field,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      SortBy,
      Offset,
      FilterOptions,
      UnfilteredPlantIds,
      null,
      null,
      -1
    );
  }
}
